import React, { useState } from 'react';
import PropTypes from 'prop-types';

export default function SerieHistoryTable({ history }) {

    const [sortColumn, setSortColumn] = useState(null);
    const [sortDirection, setSortDirection] = useState('asc');

    const handleSort = (column) => {
        if(sortColumn === column) {
            setSortDirection(sortDirection === 'asc' ? 'desc' : 'asc');
        } else {
            setSortColumn(column);
            setSortDirection('asc');
        }
    };

    const sortedHistory = [...history].sort((h1, h2) => {
        if(sortColumn === 'user') {
            const userA = `${h1.user.firstName} ${h1.user.lastName}`.toLowerCase();
            const userB = `${h2.user.firstName} ${h2.user.lastName}`.toLowerCase();
            return sortDirection === 'asc' ? userA.localeCompare(userB) : userB.localeCompare(userA);
        } else if(sortColumn === 'date') {
            const dateA = new Date(h1.date).getTime();
            const dateB = new Date(h2.date).getTime();
            return sortDirection === 'asc' ? dateA - dateB : dateB - dateA;
        } else if(sortColumn === 'score') {
            return sortDirection === 'asc' ? h1.score - h2.score : h2.score - h1.score;
        }
        return 0;
    });

    if(!history || history.length === 0) {
        return <p>Aucun historique trouvé pour cette série.</p>;
    }

    return (
        <div>
            <table className="serie-history-table">
                <thead>
                    <tr>
                        <th onClick={() => handleSort('user')}>Utilisateur {sortColumn === 'user' && (sortDirection === 'asc' ? '▲' : '▼')}</th>
                        <th onClick={() => handleSort('date')}>Date {sortColumn === 'date' && (sortDirection === 'asc' ? '▲' : '▼')}</th>
                        <th onClick={() => handleSort('score')}>Score {sortColumn === 'score' && (sortDirection === 'asc' ? '▲' : '▼')}</th>
                    </tr>
                </thead>
                <tbody>
                    {sortedHistory.map((entry) => (
                        <tr key={entry.id}>
                            <td>{entry.user.firstName} {entry.user.lastName}</td>
                            <td>{new Date(entry.date).toLocaleDateString()}</td>
                            <td>{entry.score}%</td>
                        </tr>
                    ))}
                </tbody>
            </table>
        </div>
    );
}

SerieHistoryTable.propTypes = {
    history: PropTypes.array
};
